import React, { FC, useEffect } from 'react';
import { OneColumnLayout, TwoColumnLayout } from '../../../../components/layouts';
import { useServices, useViewport } from '../../../../context';
import { MobileLoadingGrid } from './components/MobileLoadingGrid/MobileLoadingGrid';
import { LoadingGrid } from './components/LoadingGrid/LoadingGrid';
import { SideContent } from './components/LoadingGrid/SideContent';
import { PRODUCTS_BY_CATEGORY } from '../../../../consts';

interface LoadingGridWrapperProps {
  category: string;
}

export const LoadingGridWrapper: FC<LoadingGridWrapperProps> = ({ category }) => {
  const { isMobile } = useViewport();
  const { chatServiceDs: chatService } = useServices();
  const products = PRODUCTS_BY_CATEGORY[category];

  useEffect(() => {
    const createSite = async () => {
      if (!category) {
        return;
      }

      try {
        await chatService.createSiteFromTemplate(category);
        const productIds = products.map((product) => product.id);
        await chatService.updateModalystProducts(productIds);
      } catch (error) {
        console.error('Failed to create site:', error);
      }
    };

    createSite();
  }, [category, chatService, products]);

  if (isMobile) {
    return <OneColumnLayout content={<MobileLoadingGrid products={products} />} />;
  }

  return (
    <TwoColumnLayout
      mainContent={<LoadingGrid products={products} />}
      sideContent={<SideContent products={products} />}
      mainContentSpan={6}
    />
  );
};
